export const getLinkTo = (link) => {
  if (!link) return null;
  if (!link?.slug?.current) return link;
  if (link?.slug?.current) return `/${link.slug.current}/`;
  return null;
};
